import * as stylex from '@stylexjs/stylex';

// TODO: ideally these would come from design tokens long term
const ringOutline = '2px solid oklch(0.588 0.158 241)';
const destructiveOutline = '2px solid oklch(0.577 0.245 27.325)';
const focused = ':where([data-focus-visible],[data-focused],:focus-visible)';
const focusedValid = `${focused}:not([aria-invalid="true"],[data-invalid])`;
const focusedInvalid = `${focused}:where([aria-invalid="true"],[data-invalid])`;
const controlFocused = ':where([data-focus-visible],:focus-visible)';
export const focusRing = {
  control: {
    outline: "x1hr3wsb x1a2a7pz",
    outlineColor: null,
    outlineStyle: null,
    outlineWidth: null,
    outlineOffset: "x1ak7tu9",
    $$css: true
  },
  default: {
    outline: "x1a2a7pz x1ujb2d8",
    outlineColor: null,
    outlineStyle: null,
    outlineWidth: null,
    outlineOffset: "x1bx55qv",
    $$css: true
  },
  flush: {
    outline: "x1a2a7pz x1ujb2d8",
    outlineColor: null,
    outlineStyle: null,
    outlineWidth: null,
    outlineOffset: null,
    $$css: true
  },
  inset: {
    outline: "x1a2a7pz x1ujb2d8",
    outlineColor: null,
    outlineStyle: null,
    outlineWidth: null,
    outlineOffset: "x2ssjo2",
    $$css: true
  },
  withInvalid: {
    outline: "x1a2a7pz xbi0a0r xe1law9",
    outlineColor: null,
    outlineStyle: null,
    outlineWidth: null,
    outlineOffset: "x1bx55qv",
    $$css: true
  },
  container: {
    outline: "x1a2a7pz x1aj0up9",
    outlineColor: null,
    outlineStyle: null,
    outlineWidth: null,
    outlineOffset: "x1jwj5y8",
    $$css: true
  },
  containerFlush: {
    outline: "x1a2a7pz xjwntts",
    outlineColor: null,
    outlineStyle: null,
    outlineWidth: null,
    outlineOffset: null,
    $$css: true
  },
  containerInvalid: {
    outline: "x1a2a7pz xhi0gm9 x1mq3bw5",
    outlineColor: null,
    outlineStyle: null,
    outlineWidth: null,
    outlineOffset: "x1jwj5y8",
    $$css: true
  },
  none: {
    outline: "x1a2a7pz",
    outlineColor: null,
    outlineStyle: null,
    outlineWidth: null,
    outlineOffset: null,
    $$css: true
  }
};